import RenameModal from './RenameModal'

export default RenameModal
